import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Question, Words } from '../../../model';
import { ImageOptions, resourceUrl } from '../../../constant';
import { environment } from '../../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService } from '../../../../shared';

@Component({
  selector: 'app-gp2-tp5',
  templateUrl: './gp2-tp5.component.html',
  styleUrls: ['./gp2-tp5.component.css', '../../../../css/paper-layouts.component.css']
})
export class Gp2Tp5Component {

  @Input() question: Question;
  @Input() isSubmit: boolean;
  @Input() type: string;
  tempwords: Array<Words> = [];
  answers: Array<Words> = [];
  public resourceImage : string = resourceUrl;
  public defaultImage : string = ImageOptions.defaultImage;

  constructor(private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService) {

  }

  ngOnChanges(...args: any[]) {
    this.tempwords = [];
    this.answers = [];
    // if (this.question.isSkiped || this.question.isDone) {
      if (this.question.isDone) {
      this.question.answerIds.forEach(element => {
        this.answers.push(element);
      });
      this.selectCorrectAnswer(this.answers);
      this.getMatch(this.question.correctAnswer.words, this.question.answerIds).forEach(element => {
        this.tempwords.push(element);
      });
    } else {
      this.question.correctAnswer.words.forEach(element => {
        this.tempwords.push(element);
      });
      this.shuffle(this.tempwords);
      this.answers = [];
      if (this.question.answerIds) {
        this.question.answerIds.forEach(element => {
          this.answers.push(element);
        });
        this.tempwords = this.tempwords.filter((tempword) => {
          let i = this.answers.filter((answord) => {
            return answord._id == tempword._id;
          });
          if (i.length == 0) {
            return true;
          } else {
            return i[0]._id != tempword._id;
          }
        });
      }
    }
  }

  getMatch(a, b) {
    let rId = [];
    a.map((_a) => {
      return _a._id;
    }).forEach((aid) => {
      if (b.map((_b) => {
        return _b._id;
      }).indexOf(aid) == -1) {
        rId.push(aid);
      }
    });
    return a.filter((_sa) => {
      return rId.indexOf(_sa._id) >= 0;
    });
  }
  selectedWordListId(i, isAnswer) {
    this.answers.push(this.tempwords[i]);
    this.tempwords.splice(i, 1);
    this.selectCorrectAnswer(this.answers);

  }

  selectedaswersListId(i) {
    this.tempwords.push(this.answers[i]);
    this.answers.splice(i, 1);
    this.selectCorrectAnswer(this.answers);
  }

  shuffle(a) {
    var j, x, i;
    for (i = a.length; i; i--) {
      j = Math.floor(Math.random() * i);
      x = a[i - 1];
      a[i - 1] = a[j];
      a[j] = x;
    }
  }

  selectCorrectAnswer(answer) {
    let Q = this.question;
    this.question.answerIds = answer;
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-layouts/group/gp2-tp5/gp2-tp5.component.ts